import { plural } from "@lingui/macro";
import React from "react";
import InformationPill from "~/applications/OfferSearch/Ui/OfferDetails/InformationPill";
import { Person } from "~/guidelines/Icon";
import ListItemWithIcon from "~/guidelines/ListItemWithIcon";

export type CapacityAmenityProps = {
  variant?: "list-item" | "pill";
  maxCapacity: number;
};

const CapacityAmenity = ({
  variant = "list-item",
  maxCapacity,
}: CapacityAmenityProps) => {
  if (variant === "pill") {
    return (
      <InformationPill
        icon={<Person />}
        text={plural(maxCapacity, {
          one: `${maxCapacity} person`,
          other: `${maxCapacity} persons`,
        })}
      />
    );
  }

  return (
    <ListItemWithIcon icon={<Person />}>
      {plural(maxCapacity, {
        one: `${maxCapacity} person`,
        other: `${maxCapacity} persons`,
      })}
    </ListItemWithIcon>
  );
};

export default CapacityAmenity;
